var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
import CaseMarker from "~/components/common/case-marker.vue";
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { Getter, Mutation, State } from "vuex-class";
import { CaseInfoService } from "~/services/domain-service/case-info.service";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import TurnSourceApply from "~/components/apply-component/turn-source-apply.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
var TelPersonCaseManage = /** @class */ (function (_super) {
    __extends(TelPersonCaseManage, _super);
    function TelPersonCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            promiseTime: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            partnerName: '',
            batchNumber: '',
            caseMark: ''
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            apply: false
        };
        _this.applyType = ApplyType.turn;
        _this.caseChannel = CASE_CHANNEL.tel;
        _this.totalInfo = {};
        _this.userSet = [];
        return _this;
    }
    TelPersonCaseManage.prototype.mounted = function () {
        this.refreshData();
    };
    TelPersonCaseManage.prototype.activated = function () {
        // this.refreshData();
    };
    /**
     * 查询统计信息
     */
    TelPersonCaseManage.prototype.queryTotalInfo = function () {
        var _this = this;
        this.telCaseManageService
            .personalCasePoolAmount(this.paramsHandler())
            .subscribe(function (data) { return (_this.totalInfo = data); });
    };
    /**
     * 查询翻页信息
     */
    TelPersonCaseManage.prototype.queryPageInfo = function () {
        var _this = this;
        this.telCaseManageService
            .personalCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    TelPersonCaseManage.prototype.refreshData = function () {
        this.queryTotalInfo();
        this.queryPageInfo();
    };
    TelPersonCaseManage.prototype.departemntChange = function (id, code) { };
    /**
     * 表单范围输入框重置
     */
    TelPersonCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
        this.model.personalCollectionRemainingDays = { min: '', max: "" };
    };
    TelPersonCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.promiseTimeMin = this.$filter.dateRanageFormat(this.model.promiseTime).start;
        params.promiseTimeMax = this.$filter.dateRanageFormat(this.model.promiseTime).end;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        delete params.promiseTime;
        return params;
    };
    /**
     * 进入查看执行页
     */
    TelPersonCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Tel_personal,
            otherData: {
                data: this.model,
                page: this.pageService,
                sort: this.sortService
            }
        });
    };
    /**
     * 申请流转
     */
    TelPersonCaseManage.prototype.advanceCirculation = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要流转的案件");
            return;
        }
        this.dialog.apply = true;
    };
    Object.defineProperty(TelPersonCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    TelPersonCaseManage.prototype.onColorChange = function (val) {
        var colorModel = {
            caseIds: this.selectionList.map(function (v) { return v.id; }),
            caseMark: val
        };
        this.caseInfoService
            .caseInfoMarkColor(colorModel)
            .subscribe(this.refreshData);
    };
    __decorate([
        Dependencies(PageService)
    ], TelPersonCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TelPersonCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], TelPersonCaseManage.prototype, "telCaseManageService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], TelPersonCaseManage.prototype, "caseInfoService", void 0);
    __decorate([
        Mutation
    ], TelPersonCaseManage.prototype, "updateCollectionType", void 0);
    __decorate([
        Getter
    ], TelPersonCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        State
    ], TelPersonCaseManage.prototype, "principalList", void 0);
    TelPersonCaseManage = __decorate([
        Auth(202),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                CaseMarker: CaseMarker,
                GetLabelName: GetLabelName,
                TurnSourceApply: TurnSourceApply,
                SelectDepartment: SelectDepartment
            }
        })
    ], TelPersonCaseManage);
    return TelPersonCaseManage;
}(Vue));
export default TelPersonCaseManage;
